import { useSelector } from 'react-redux';
import { Videos } from '../../components/Videos';
import { selectVideos } from '../../selectors/builder';
import * as React from 'react';
import { useVideoSize } from './hooks/useVideoSize';

export const VideosContainer = () => {
  const videos = useSelector(selectVideos);
  const { ref, ...containerSize } = useVideoSize();

  if (!videos?.length) {
    return null;
  }

  return <Videos items={videos} {...containerSize} ref={ref} />;
};
